"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Search = exports.SearchResult = void 0;
const cash_dom_1 = __importDefault(require("cash-dom"));
class SearchResult {
    constructor() {
        this.locale = "de";
        this.term = "";
        this.events = [];
        this.news = [];
        this.pages = [];
    }
}
exports.SearchResult = SearchResult;
class Search {
    constructor(container) {
        var _a, _b;
        this.lang = 'de';
        this.container = null;
        this.searchInput = null;
        this.searchResults = null;
        this.searchResultsEmpty = null;
        this.searchTerm = "";
        this.templateResult = "";
        this.results = new SearchResult();
        // init search field and results
        this.container = container;
        this.lang = (_b = (_a = document.getElementsByTagName('html')) === null || _a === void 0 ? void 0 : _a[0].getAttribute('lang')) !== null && _b !== void 0 ? _b : 'de';
        this.searchInput = (0, cash_dom_1.default)('input[name="term"]', container);
        this.searchResults = (0, cash_dom_1.default)('#search-results', container);
        this.searchResultsEmpty = (0, cash_dom_1.default)('#no-search-results', container);
        this.templateResult = (0, cash_dom_1.default)('#search_result_template', container).html();
        if (!this.searchInput || this.searchInput.length == 0) {
            return;
        }
        this.init();
    }
    init() {
        this.searchTerm = (0, cash_dom_1.default)(this.searchInput[0]).val().toString();
        (0, cash_dom_1.default)(this.searchInput[0]).on('keyup', () => {
            this.searchTerm = (0, cash_dom_1.default)(this.searchInput[0]).val().toString();
            if (this.searchTerm.length >= 3) {
                let data = this.querySearch(this.searchTerm);
                data.then((response) => {
                    if (response.events.length == 0 && response.news.length == 0 && response.pages.length == 0) {
                        this.searchResultsEmpty.show();
                    }
                    else {
                        this.searchResultsEmpty.hide();
                    }
                    this.parseEvents(response.events);
                    this.parseNews(response.news);
                    this.parsePages(response.pages);
                });
            }
        });
    }
    querySearch(term = "") {
        return __awaiter(this, void 0, void 0, function* () {
            return yield fetch(`api/search/?term=${term}`, {
                method: 'GET',
                headers: {
                    'accept-language': this.lang,
                    'Content-Type': 'application/json'
                }
            })
                .then(response => response.json())
                .catch(err => console.log(err));
        });
    }
    parseEvents(events) {
        (0, cash_dom_1.default)('.result.events li.click-rel', this.searchResults).remove();
        if (!events || events.length == 0) {
            (0, cash_dom_1.default)('.result.events', this.searchResults).hide();
            (0, cash_dom_1.default)('.result.events li.no-results', this.searchResults).show();
            return;
        }
        (0, cash_dom_1.default)('.result.events', this.searchResults).show();
        (0, cash_dom_1.default)('.result.events li.no-results', this.searchResults).hide();
        events.forEach((event) => {
            (0, cash_dom_1.default)('.result.events .result-list', this.searchResults).append(this.parseTemplate(`/event/${event.id}`, this.lang == 'de' ? event.headline_1_de : event.headline_1_en, event.company));
        });
    }
    parseNews(news) {
        (0, cash_dom_1.default)('.result.news li.click-rel', this.searchResults).remove();
        if (!news || news.length == 0) {
            (0, cash_dom_1.default)('.result.news', this.searchResults).hide();
            (0, cash_dom_1.default)('.result.news li.no-results', this.searchResults).show();
            return;
        }
        (0, cash_dom_1.default)('.result.news', this.searchResults).show();
        (0, cash_dom_1.default)('.result.news li.no-results', this.searchResults).hide();
        news.forEach((news_item) => {
            (0, cash_dom_1.default)('.result.news .result-list', this.searchResults).append(this.parseTemplate(`/news/${news_item.id}`, this.lang == 'de' ? news_item.title_de : news_item.title_en, this.lang == 'de' ? news_item.short_de : news_item.short_en));
        });
    }
    parsePages(pages) {
        (0, cash_dom_1.default)('.result.pages li.click-rel', this.searchResults).remove();
        if (!pages || pages.length == 0) {
            (0, cash_dom_1.default)('.result.pages', this.searchResults).hide();
            (0, cash_dom_1.default)('.result.pages li.no-results', this.searchResults).show();
            return;
        }
        (0, cash_dom_1.default)('.result.pages', this.searchResults).show();
        (0, cash_dom_1.default)('.result.pages li.no-results', this.searchResults).hide();
        pages.forEach((page) => {
            (0, cash_dom_1.default)('.result.pages .result-list', this.searchResults).append(this.parseTemplate(`/page/${page.id}`, this.lang == 'de' ? page.title_de : page.title_en, this.lang == 'de' ? page.subline_de : page.subline_en));
        });
    }
    parseTemplate(url, headline, subline) {
        return this.templateResult.toString().replaceAll('#URL#', url).replace('#HEADLINE#', headline !== null && headline !== void 0 ? headline : '').replace('#SUBLINE#', subline !== null && subline !== void 0 ? subline : '');
    }
}
exports.Search = Search;
